// VesselChangeType values, hand-sync'ed with PortCall.Models\Vessels\VesselChange.cs
export enum VesselChangeType {
    BowThrusterPresent              = 'BT',
    BowThrusterSize                 = 'BS',
}



// WEBPACK FOOTER //
// ./data/models/VesselChangeType.ts